export const CCD_ALL_DATA_ROLE = "ccd_all_data";
export const CCD_NO_CRO_ROLE = "ccd_no_cro";
export const CCD_NO_CDMO_ROLE = "ccd_no_cdmo";
